<div class="sc-wrapper" tabindex="0" (mouseenter)="checkTooltipPosition($event)" (focus)="checkTooltipPosition($event)">

  <!-- ── Card ─────────────────────────────────────────────────────── -->
  <div class="h-full stats-card flex flex-col justify-between transition-all duration-300 med-surface">

    <!-- Header: title + coloured icon bubble -->
    <div class="flex items-center justify-between gap-2">
      <h3 class="stats-card-title truncate" [attr.title]="title">{{ title }}</h3>
      <div *ngIf="icon"
        [ngClass]="[iconBgClass, 'icon-container rounded-lg w-7 h-7 flex items-center justify-center flex-shrink-0 transition-all duration-300']">
        <i [class]="tablerIconClass" [ngClass]="[iconColorClass, 'text-base']"></i>
      </div>
    </div>

    <!-- Content Switch -->
    <ng-container [ngSwitch]="currentMode">

      <!-- Simple Mode: Single Value -->
      <div *ngSwitchCase="'simple'" class="flex items-baseline gap-2 mt-auto">
        <div *ngIf="!isLoading" [ngClass]="[valueColorClass, 'stats-simple-value']">{{ displayValue }}</div>
        <div *ngIf="isLoading" class="flex items-center justify-start h-7">
          <div class="spinner"></div>
        </div>
        <span *ngIf="delta && !isLoading" class="delta-inline" [class.delta-pos]="deltaPositive"
          [class.delta-neg]="!deltaPositive">
          <svg *ngIf="deltaPositive" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="18 15 12 9 6 15" />
          </svg>
          <svg *ngIf="!deltaPositive" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
          {{ delta | slice:1 }}
        </span>
      </div>

      <!-- Detailed Mode: Item Rows -->
      <div *ngSwitchCase="'detailed'" class="mt-2 space-y-1.5">
        <ng-container *ngIf="!isLoading">
          <div *ngFor="let item of items"
            class="flex flex-row justify-between items-center px-2.5 py-1.5 bg-slate-50/60 hover:bg-slate-100/60 border border-slate-100/40 rounded-lg transition-all duration-200">
            <span class="stats-label text-slate-500 truncate">{{ item.label }}</span>
            <span class="stats-value font-semibold text-right" [ngClass]="item.colorClass || valueColorClass">{{
              item.value }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="isLoading">
          <div class="flex flex-col items-center justify-center py-4 space-y-2 w-full">
            <div class="spinner"></div>
            <span class="text-[10px] text-slate-400 font-medium">Updating...</span>
          </div>
        </ng-container>
      </div>

    </ng-container>
  </div>

  <!-- ── Tooltip ───────────────────────────────────────────────────── -->
  <div class="sc-tooltip" [class.sc-tooltip-bottom]="showTooltipAtBottom" *ngIf="!isLoading">
    <div class="sc-tt-label">{{ title }}</div>

    <!-- Simple: full value + delta -->
    <ng-container *ngIf="currentMode === 'simple'">
      <div class="sc-tt-value">{{ fullValue }}</div>
      <div *ngIf="delta" class="sc-tt-delta" [class.sc-tt-pos]="deltaPositive" [class.sc-tt-neg]="!deltaPositive">
        <svg *ngIf="deltaPositive" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="18 15 12 9 6 15" />
        </svg>
        <svg *ngIf="!deltaPositive" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="6 9 12 15 18 9" />
        </svg>
        {{ delta | slice:1 }} vs last period
      </div>
    </ng-container>

    <!-- Detailed: all item rows -->
    <ng-container *ngIf="currentMode === 'detailed'">
      <div *ngFor="let item of items" class="sc-tt-row">
        <span class="sc-tt-row-label">{{ item.label }}</span>
        <span class="sc-tt-row-val" [ngClass]="item.colorClass || ''">{{ item.value }}</span>
      </div>
    </ng-container>

    <div class="sc-tt-arrow" [class.sc-tt-arrow-bottom]="showTooltipAtBottom"></div>
  </div>

</div>